export default {
  domains: {
    Condition: "condition_occurrence",
    Drug: "drug_exposure",
    Device: "device_exposure",
    Measurement: "measurement",
    Procedure: "procedure_occurrence",
    Observation: "observation",
  },
};
